import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import React, { FC } from "react";

type QuizDimensionHeaderProps = {
  title: string;
  description: string;
  icon?: React.ElementType;
  color?: string;
  percent: number;
  scoreProportion: number;
  answeredQuestions: number;
  totalQuestions: number;
  completedTopics: number;
  totalTopics: number;
  showWeight?: boolean;
  children?: React.ReactNode;
};

const QuizDimensionHeader: FC<QuizDimensionHeaderProps> = (props) => {
  const Icon = props.icon;

  const finalColor = props.color || "#f1f5f9";

  const { showWeight = true } = props;

  return (
    <Card className="rounded-xl">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2">
          <div
            style={{ backgroundColor: finalColor }}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white"
          >
            {Icon && <Icon size={20} />}
          </div>

          <div className="grow">
            <h2 className="color-[#293038] text-3xl font-semibold">
              {props.title}
            </h2>

            {showWeight && props.scoreProportion != null && (
              <p className="text-xs font-bold text-[#8090A3]">
                Puntaje Ponderado: {props.scoreProportion} puntos
              </p>
            )}
          </div>
        </div>
      </CardHeader>

      <CardContent className="flex flex-col gap-3">
        {props.description && <p className="text-sm">{props.description}</p>}

        <div className="flex flex-col gap-4 text-xs text-[#293038] lg:flex-row">
          <div className="flex flex-row gap-20">
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <p className="font-bold">Has completado</p>
                  <p>
                    {props.completedTopics}/{props.totalTopics} temas
                  </p>
                </div>
              </TooltipTrigger>
              <TooltipContent className="max-w-sm">
                Cantidad de preguntas en las que has proporcionado toda la
                información requerida.
              </TooltipContent>
            </Tooltip>

            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <p className="font-bold">Has respondido</p>
                  <p>
                    {props.answeredQuestions}/{props.totalQuestions} preguntas
                  </p>
                </div>
              </TooltipTrigger>
              <TooltipContent className="max-w-sm">
                Cantidad de preguntas que has contestado pero que pueden
                necesitar más información.
              </TooltipContent>
            </Tooltip>
          </div>

          <div className="grow">{props.children}</div>
        </div>

        <div className="group">
          <p className="mb-1 text-[13px] font-normal text-[#8090A3]">
            {props.percent}% completado
          </p>

          <Progress
            value={props.percent}
            indicatorColor={props.color}
            className="h-2.5"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default QuizDimensionHeader;
